module.exports = __webpack_public_path__ + "static/media/rsz_pexels-photo-302899.fad0bd20.jpg";